import {
  jb_region_indicator_item_css_default
} from "./chunk.DUNJBAJH.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  n
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-region-indicator-item/jb-region-indicator-item.ts
var JbRegionIndicatorItem = class extends r {
  constructor() {
    super(...arguments);
    this.hasGlobe = false;
  }
  render() {
    return ke`
      <span
        role="listitem"
        aria-label="${this.ariaLabels?.label ?? this.textFull}"
      >
        ${this.hasGlobe ? ke`<jb-globe-icon><span class="short">${this.text}</span><span>${this.textFull}</span></jb-globe-icon>` : ke`<span class="short">${this.text}</span><span>${this.textFull}</span>`}
      </span>
    `;
  }
};
JbRegionIndicatorItem.styles = jb_region_indicator_item_css_default;
__decorateClass([
  n({ type: Object })
], JbRegionIndicatorItem.prototype, "ariaLabels", 2);
__decorateClass([
  n({ type: Boolean })
], JbRegionIndicatorItem.prototype, "hasGlobe", 2);
__decorateClass([
  n()
], JbRegionIndicatorItem.prototype, "text", 2);
__decorateClass([
  n()
], JbRegionIndicatorItem.prototype, "textFull", 2);
JbRegionIndicatorItem = __decorateClass([
  customElement("jb-region-indicator-item")
], JbRegionIndicatorItem);

export {
  JbRegionIndicatorItem
};
